import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { makeQueryBuilder, makeQueryRules, TableFilterType } from '@ui/ui.module';

export function checkUniqueCodeDuplicate<T>(
  getter: (params: { filter?: TableFilterType, page?: number, limit?: number }) => Observable<{ data: T[], count: number }>,
  countLimit = 1,
): AsyncValidatorFn {
  return (control: AbstractControl) => {
    const rules = makeQueryRules(
      { codiceUnico: control.value },
      { codiceUnico: { operator: 'equal' } },
    );
    const filter = makeQueryBuilder(rules);

    return getter({ filter, page: 1, limit: 10 }).pipe(
      map((page) => page.count > countLimit),
      map((greater) => greater ? { duplicate: true } : null),
      first(),
    );
  };
}
